import { EdTabsHeaderOption } from '@/models/ed-tabs-header-option.model';
import Vue from 'vue';
import Component from 'vue-class-component';
import { 
  ALL_CONTENT_MENU,
} from '../../values/my-content.values';
import KEYS from '@/values/keys';
import { MY_CONTENT_STORE } from '../../store/my-content.store';
import EdFilterTemplate from '@/course-templates/components/ed-filter-template/ed-filter-template.component.vue';
import { AuthProvider } from '@/auth/providers/auth.provider';

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate'
])

@Component({
  name: 'all',
  components: {
    EdFilterTemplate
  }
})
export default class AllView extends Vue {

  get routePath() {
    return this.$route.path;
  }

  get menu(): EdTabsHeaderOption[] {
    return ALL_CONTENT_MENU
      .filter(
        m => AuthProvider.isUserAllowed(m.hideForRoles || [])
      ).map((m: any, i :number) => {
        let path = m.path;
        if(m.path) {
          const currentPath = this.$route.path;
          const isInAlls = currentPath.includes('all/');
          path = isInAlls ? m.path.replace('all/', '') : m.path;
        }
        return new EdTabsHeaderOption({
          id: i,
          name: m.name,
          label: this.$i18n.t(`myContent.headerMenu.${m.name}`),
          path,
          active: false,
          disabled: m.disabled,
        })
      });
  }

  get isTemplateTabSelected() {
    return this.routePath.includes('templates');
  }

  beforeRouteLeave(to, from, next) {
    this.$store.commit(MY_CONTENT_STORE.MUTATIONS.INIT_COURSES);
    next();
  }


  mounted() {
    this.$App.Store.setSubjectBuilderActive(true);
  }
  
  beforeDestroy() {
    this.$App.Store.setSubjectBuilderActive(false);
  }

}